export class Context {
    listeners: { [key: string]: Function[] } = {};

    addListener(key: string, listener: Function) {
        if (!this.listeners[key]) {
            this.listeners[key] = [];
        }
        this.listeners[key].push(listener);

        listener();
    }

    removeListener(key: string, listener: Function) {
        if (this.listeners[key]) {
            this.listeners[key] = this.listeners[key].filter(l => l !== listener);
        }
    }

    notify(key: string) {
        this.listeners[key]?.forEach(listener => listener());
    }
}